import { render } from "./RegistrarProductoModal.vue?vue&type=template&id=4d0aad7e&scoped=true"
import script from "./RegistrarProductoModal.vue?vue&type=script&lang=js"
export * from "./RegistrarProductoModal.vue?vue&type=script&lang=js"

import "./RegistrarProductoModal.vue?vue&type=style&index=0&id=4d0aad7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0aad7e"]])

export default __exports__